import React from "react";
import ThisWeekPeople from "./ThisWeekPeople";
import NextWeekPeople from "./NextWeekPeople";
import LastWeekPeople from "./LastWeekPeople";
import "./SmtsTabs.css";
import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from "@syncfusion/ej2-react-navigations";

function SmtsPeople() {
  let headerText = [
    { text: "This Week" },
    { text: "Next Week" },
    { text: "Last Week" },
  ];

  return (
    <div className="main-tab-container">
      <TabComponent>
        <TabItemsDirective>
          <TabItemDirective header={headerText[0]} content={ThisWeekPeople} />
          <TabItemDirective header={headerText[1]} content={NextWeekPeople} />
          <TabItemDirective header={headerText[2]} content={LastWeekPeople} />
        </TabItemsDirective>
      </TabComponent>
    </div>
  );
}

export default SmtsPeople;
